'use strict';
'use es6';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Ajax = require('./utils/Ajax');

var _Ajax2 = _interopRequireDefault(_Ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HubDbClient = function () {
  function HubDbClient() {
    _classCallCheck(this, HubDbClient);
  }

  _createClass(HubDbClient, [{
    key: 'getTable',
    value: function getTable(portalId, tableId, callback) {
      return _Ajax2.default.get(HubDbClient.apiPath + '/tables/' + tableId + '?portalId=' + portalId, callback);
    }
  }, {
    key: 'getRow',
    value: function getRow(portalId, tableId, rowId, callback) {
      return _Ajax2.default.get(HubDbClient.apiPath + '/tables/' + tableId + '/rows/' + rowId + '?portalId=' + portalId, callback);
    }
  }, {
    key: 'listRows',
    value: function listRows(portalId, tableId) {
      var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var callback = arguments[3];

      if (query.startsWith('?') || query.startsWith('&')) {
        query = query.substring(1);
      }

      return _Ajax2.default.get(HubDbClient.apiPath + '/tables/' + tableId + '/rows?portalId=' + portalId + '&' + query, callback);
    }
  }], [{
    key: 'apiPath',
    get: function get() {
      return 'https://api.hubapi.com/hubdb/api/v2';
    }
  }]);

  return HubDbClient;
}();

window.hubdbClient = new HubDbClient();


//////////////////
// WEBPACK FOOTER
// ./js/HubDbClient.js
// module id = 0
// module chunks = 1